<template>
  <div>
    <ClientStrategyForm
      v-if="showForm"
      :strategies="strategies"
      :stage="stage"
      :stages="data"
      :lastStageDate="lastStageDate"
      :unfinishedGoals="unfinishedGoals"
      v-on:submit="submitForm"
      v-on:cancel="closeForm"/>

    <div class="py-3">
      <button
        class="btn btn-primary"
        @click="createStage">
        Добавить этап
      </button>
    </div>

    <ClientStrategyList
        title="Текущие стратегии"
        :strategies="strategies"
        :stages="current"
        v-on:select="selectStage"
        v-on:change="changeStatus" />

    <ClientStrategyList
        title="Завершенные стратегии"
        :strategies="strategies"
        :stages="past"
        v-on:select="selectStage"
        v-on:change="changeStatus" />
  </div>
</template>

<script>
import ClientStrategyList from './strategy/List';
import ClientStrategyForm from './strategy/Form';

export default {
  name: 'ClientStrategy',

  components: {
    ClientStrategyList,
    ClientStrategyForm,
  },

  props: ['client'],

  data() {
    return {
      loading: false,
      error: '',
      success: '',
      showForm: false,
      stageId: null,
      unfinishedGoals: [],
    };
  },

  created() {
    this.loadData();
  },

  computed: {
    stage() {
      return this.stages.find(i => i.id === this.stageId);
    },

    strategies() {
      return this.$store.state.clinic.strategies;
    },

    stages() {
      return this.$store.getters.clientStages(this.client.id);
    },

    data() {
      return this.stages.map(stage => {
        const {id, title, dateFrom, dateTo} = stage;
        let hasUnfinished = false;
        const goals = stage.goals.map(goal => {
          const {id, strategy: strategyId, status} = goal;
          const strategy = this.strategies.find(i => i.id === strategyId);

          if (!['achieved', 'canceled'].includes(status)) {
            hasUnfinished = true;
          }

          return {id, strategy, status};
        });

        return {id, title, goals, dateFrom, dateTo, finished: !hasUnfinished};
      });
    },

    current() {
      return this.data.filter(i => i.finished === false);
    },

    past() {
      return this.data.filter(i => i.finished === true);
    },

    lastStageDate() {
      let lastStageDate = new Date();

      for(const stage of this.stages) {
        const lastDate = new Date(stage.dateTo);

        if (lastDate.getTime() > lastStageDate.getTime()) {
          lastStageDate = lastDate;
        }
      }

      return lastStageDate;
    },
  },

  methods: {
    async loadData() {
      try {
        this.loading = true;

        await Promise.all([
          this.$store.dispatch('LOAD_STRATEGIES'),
          this.$store.dispatch('LOAD_STAGES', this.client.id),
        ]);
      } catch (e) {
        this.error = e.message;
      }

      this.loading = false;
    },

    createStage() {
      this.unfinishedGoals = [];

      let lastFinished = null;

      for (const stage of this.past) {
        if (lastFinished === null || new Date(stage.dateTo) > new Date(lastFinished.dateTo)) {
          lastFinished = stage;
        }
      }

      if (lastFinished !== null) {
        for (const goal of lastFinished.goals) {
          if (goal.status === 'canceled') {
            this.unfinishedGoals.push(goal.strategy.id);
          }
        }
      }

      this.showForm = true;
    },

    selectStage(id) {
      const stage = this.stages.find(i => i.id === id);

      this.unfinishedGoals = [];

      if (typeof stage !== 'undefined') {
        this.stageId = stage.id;
        this.showForm = true;
      }
    },

    async submitForm(data) {
      this.loading = true;

      try {
        const { id, title, goals, dateFrom, dateTo } = data;
        const params = {
          id,
          user: this.client.id,
          title,
          goals,
          dateFrom,
          dateTo,
        };

        if (typeof params.id !== 'undefined') {
          await this.$store.dispatch('UPDATE_STAGE', params);

          this.success = `Этап успешно обновлен`;
        } else {
          await this.$store.dispatch('ADD_STAGE', params);

          this.success = `Этап успешно добавлен`;
        }
      } catch (e) {
        this.error = e.message;
      }

      this.loading = false;
      this.closeForm();
    },

    closeForm() {
      this.stageId = null;
      this.showForm = false;
    },

    async changeStatus({id, stage, status}) {
      this.loading = true;

      try {
        const params = {id, status, stage, user: this.client.id};

        await this.$store.dispatch('CHANGE_GOAL_STATUS', params);
      } catch (e) {
        this.error = e.message;
      }

      this.loading = false;
    }
  },
};
</script>
